import { useState } from 'react';
import { useModal } from '@/hooks/useModal';

export const useBroadcastModals = () => {
    const testSend = useModal();
    const preview = useModal();
    const schedule = useModal();
    const deleteModal = useModal();
    const unschedule = useModal();

    // Delete modal state
    const [deleteData, setDeleteData] = useState<{
        flowId: number | null;
        flowName: string;
    }>({
        flowId: null,
        flowName: '',
    });

    const openSchedule = () => {
        preview.close();
        schedule.open();
    };

    const showPreviewFromSchedule = () => {
        schedule.close();
        preview.open();
    };

    const openDelete = (flowId: number, flowName: string) => {
        setDeleteData({ flowId, flowName });
        deleteModal.open();
    };

    const closeDelete = () => {
        deleteModal.close();
        // Wait for modal animation to finish before clearing data
        setTimeout(() => {
            setDeleteData({ flowId: null, flowName: '' });
        }, 300);
    };

    return {
        testSend,
        preview,
        schedule: { ...schedule, open: openSchedule },
        showPreviewFromSchedule,
        unschedule,
        delete: {
            isOpen: deleteModal.isOpen,
            flowId: deleteData.flowId,
            flowName: deleteData.flowName,
            open: openDelete,
            close: closeDelete,
        },
    };
};
